import React from 'react'
import { Route } from 'react-router'
import RedirectToPlural from '@/modules/layout/util/redirectToPlural'

const CustomerList = React.lazy(() => import('./components/list/customer-list'))
const CustomerDetails = React.lazy(() => import('./components/detail/customer-detail'))
const CustomerEdit = React.lazy(() => import('./components/customer-edit'))

const customerRoutes = (
  <>
    <Route path='customer/*' element={<RedirectToPlural />} />
    <Route path='customers' Component={CustomerList} handle={{ title: 'Kunden', options: { noBackgroundColor: true } }} />
    <Route path='customers/:id' Component={CustomerDetails} />
    <Route path='customers/edit/:id/:hash?' Component={CustomerEdit} />
    <Route path='customers/new' Component={CustomerEdit} />
  </>
)

export default customerRoutes
